<template>
  <div class="carousel-controls">
    <button
      class="carousel-controls__play bg-white text-ca-green shadow-2"
      type="button"
      :aria-label="isPlaying ? 'Pausar' : 'Reproduzir'"
      @click="$emit('toggle-play')"
    >
      <!-- Pause/Stop icons -->
      <template v-if="isPlaying">
        <!-- Outline (default/focus) -->
        <svg class="carousel-controls__play-svg carousel-controls__icon-outline" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.05762 5.9082C8.05762 5.6819 7.87469 5.49826 7.64844 5.49805L5.9082 5.49805C5.68177 5.49805 5.49805 5.68177 5.49805 5.9082L5.49805 18.0879C5.49805 18.3143 5.68177 18.498 5.9082 18.498L7.64844 18.498C7.87469 18.4978 8.05762 18.3142 8.05762 18.0879L8.05762 5.9082ZM9.55762 18.0879C9.55762 19.1426 8.70312 19.9978 7.64844 19.998L5.9082 19.998C4.85334 19.998 3.99805 19.1428 3.99805 18.0879L3.99805 5.9082C3.99805 4.85334 4.85334 3.99805 5.9082 3.99805L7.64844 3.99805C8.70312 3.99826 9.55762 4.85347 9.55762 5.9082L9.55762 18.0879Z" fill="currentColor"/>
          <path d="M18.499 5.9082C18.499 5.6819 18.3161 5.49826 18.0898 5.49805L16.3496 5.49805C16.1232 5.49805 15.9395 5.68177 15.9395 5.9082L15.9395 18.0879C15.9395 18.3143 16.1232 18.498 16.3496 18.498L18.0898 18.498C18.3161 18.4978 18.499 18.3142 18.499 18.0879L18.499 5.9082ZM19.999 18.0879C19.999 19.1426 19.1445 19.9978 18.0898 19.998L16.3496 19.998C15.2947 19.998 14.4395 19.1428 14.4395 18.0879L14.4395 5.9082C14.4395 4.85334 15.2947 3.99805 16.3496 3.99805L18.0898 3.99805C19.1445 3.99826 19.999 4.85347 19.999 5.9082L19.999 18.0879Z" fill="currentColor"/>
        </svg>
        <!-- Filled (hover/pressed) -->
        <svg class="carousel-controls__play-svg carousel-controls__icon-filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.55762 18.0879C9.55762 19.1426 8.70312 19.9978 7.64844 19.998L5.9082 19.998C4.85334 19.998 3.99805 19.1428 3.99805 18.0879L3.99805 5.9082C3.99805 4.85334 4.85334 3.99805 5.9082 3.99805L7.64844 3.99805C8.70312 3.99826 9.55762 4.85347 9.55762 5.9082L9.55762 18.0879Z" fill="currentColor"/>
          <path d="M19.999 18.0879C19.999 19.1426 19.1445 19.9978 18.0898 19.998L16.3496 19.998C15.2947 19.998 14.4395 19.1428 14.4395 18.0879L14.4395 5.9082C14.4395 4.85334 15.2947 3.99805 16.3496 3.99805L18.0898 3.99805C19.1445 3.99826 19.999 4.85347 19.999 5.9082L19.999 18.0879Z" fill="currentColor"/>
        </svg>
      </template>
      <!-- Play icons -->
      <template v-else>
        <!-- Outline (default/focus) -->
        <svg class="carousel-controls__play-svg carousel-controls__icon-outline" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.65039 4.76172C4.65039 3.1743 6.36766 2.20342 7.73926 2.96191L20.2842 9.89941L20.4131 9.97656C21.663 10.7835 21.663 12.6149 20.4131 13.4219L20.2842 13.499L7.73926 20.4365C6.36882 21.1951 4.65039 20.2239 4.65039 18.6367L4.65039 4.76172ZM6.15039 18.6367C6.15039 19.0503 6.61487 19.3442 7.0127 19.124L19.5586 12.1855L19.627 12.1416C19.9247 11.9198 19.9247 11.4786 19.627 11.2568L19.5586 11.2129L7.01367 4.27441C6.61426 4.05353 6.15039 4.34807 6.15039 4.76172L6.15039 18.6367Z" fill="currentColor"/>
        </svg>
        <!-- Filled (hover/pressed) -->
        <svg class="carousel-controls__play-svg carousel-controls__icon-filled" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.65039 4.76172C4.65039 3.1743 6.36766 2.20342 7.73926 2.96191L20.2842 9.89941L20.4131 9.97656C21.663 10.7835 21.663 12.6149 20.4131 13.4219L20.2842 13.499L7.73926 20.4365C6.36882 21.1951 4.65039 20.2239 4.65039 18.6367L4.65039 4.76172Z" fill="currentColor"/>
        </svg>
      </template>
    </button>
    <div
      class="carousel-controls__progress bg-white shadow-2"
      role="group"
      :aria-label="`Controlo de página. Slide ${activeSlide + 1} de ${slideCount}`"
    >
      <button
        v-for="(slide, idx) in slideCount"
        :key="idx"
        class="carousel-controls__dot bg-ca-green-30"
        :class="{ 'carousel-controls__dot--active': idx === activeSlide }"
        type="button"
        :aria-label="`Ir para slide ${idx + 1} de ${slideCount}`"
        :aria-current="idx === activeSlide ? 'true' : undefined"
        @click="$emit('go-to-slide', idx)"
      >
        <span
          v-if="idx === activeSlide"
          class="carousel-controls__dot-fill bg-ca-green"
          :style="{ transform: `scaleX(${dotProgress / 100})` }"
        ></span>
      </button>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: "CarouselControls",
});

defineProps({
  slideCount: {
    type: Number,
    required: true,
  },
  activeSlide: {
    type: Number,
    default: 0,
  },
  isPlaying: {
    type: Boolean,
    default: true,
  },
  dotProgress: {
    type: Number,
    default: 0,
  },
});

defineEmits(["toggle-play", "go-to-slide"]);
</script>

<style scoped lang="scss">
.carousel-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.carousel-controls__play {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus-visible {
    outline: none;

    &::after {
      content: "";
      position: absolute;
      inset: -3px;
      border-radius: 50%;
      border: 1px solid #0a8bff;
      pointer-events: none;
    }
  }

  &:hover,
  &:active {
    .carousel-controls__icon-outline {
      display: none;
    }
    .carousel-controls__icon-filled {
      display: block;
    }
  }

  &:active {
    color: #043D28;
  }
}

.carousel-controls__play-svg {
  width: 24px;
  height: 24px;
}

.carousel-controls__icon-outline {
  display: block;
}

.carousel-controls__icon-filled {
  display: none;
}

.carousel-controls__progress {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  padding: 8px;
}

.carousel-controls__dot {
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 36px;
  border: none;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  transition: width 0.2s ease;
}

.carousel-controls__dot--active {
  width: 40px;
  height: 12px;
  border-radius: 36px;
}

.carousel-controls__dot-fill {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  transform-origin: left;
  transform: scaleX(0);
}

@media (max-width: 767px) {
  .carousel-controls__dot {
    width: 8px;
    height: 8px;
  }

  .carousel-controls__dot--active {
    width: 24px;
    height: 8px;
  }
}
</style>
